export const bWareCategorySlug = "b-ware"
export const bWareTitle = "B-Ware"
export const bWareDescription =
  "B-Ware kann optische Mängel haben oder Schäden an der Verpackung. Technisch sind die Produkte einwandfrei."
